import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ProcessStepV2 from './ProcessStepV2';
import { getProcessSteps } from '../landing/landingContent';
import { createGTMTracking, getGTMAttributes } from '../../utils/gtm/gtm-tracking';

export const ProcessSectionV2: React.FC = () => {
  const { t } = useTranslation('marketing');
  const processSteps = useMemo(() => getProcessSteps(t), [t]);

  return (
    <section
      id="how-it-works"
      className="flex flex-col relative items-center gap-8 sm:gap-10 lg:gap-[60px] w-full box-border bg-white pt-12 sm:pt-14 pb-12 sm:pb-14 lg:pb-20 px-4 sm:px-6 lg:px-20"
      {...getGTMAttributes(createGTMTracking('SECTION_VIEWED', { origin: 'welcome_page', target: 'how_it_works' }))}
    >
      <div
          className="absolute inset-0 w-full h-full mx-8"
          style={{
            background: `radial-gradient(circle at 2px 2px, rgba(23, 29, 39, 0.15) 2px, transparent 0)`,
            backgroundSize: '50px 50px'
          }}
        />

      <motion.header
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.05 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="text-center px-6"
      >
        <h2 className="text-dark-invirtus text-2xl sm:text-3xl lg:text-5xl font-bold leading-tight sm:leading-[40px] lg:leading-[48px] tracking-[-0.192px]">
          {t('process.title')}
        </h2>
      </motion.header>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.05 }}
        transition={{ duration: 0.4, delay: 0.05, ease: "easeOut" }}
        className="flex flex-col items-center gap-12 sm:gap-16 lg:gap-[100px] w-full max-w-screen-xl"
      >
        <div className="relative w-full">
          <ProcessStepV2 {...processSteps[0]} step="step_1" />
        </div>

        <div className="relative w-full pt-8 sm:pt-14">
          <ProcessStepV2 {...processSteps[1]} step="step_2" />
        </div>

        <div className="w-full pt-8 sm:pt-14">
          <ProcessStepV2 {...processSteps[2]} step="step_3" />
        </div>
      </motion.div>
    </section>
  );
};
